import React, { Component } from 'react';
import { Modal, Form, Input, Row} from 'antd';
import MemberSelect from '../member/MemberSelect';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import validator from '../../../util/validator';

const fields = [ 
// {
//     "text": "所属会员",
//     "field": "memberCode",
//     rules: [
//         { required: true, message: '所属会员不能为空!' },
//         { max: 32, message: '所属会员不能超过32个字符！' },
//     ]
// },
{
    "text": "所属会员",
    "field": "memberCode",
    "member": true,
    rules: [
        { required: true, message: '所属会员不能为空!' }
    ],
}
,{
    "text": "公司名称",
    "field": "memberName",
    rules: [
        { required: true, message: '公司名称不能为空!' },
        { max: 32, message: '会员名不能超过32个字符！' },
    ]
}
,{
    "text": "证件号码",
    "field": "memberCreditNo",
    rules: [
        { required: true, message: '证件号码不能为空!' },
        { max: 32, message: '证件号码不能超过32个字符！' },
    ]
}
,{
    "text": "户名",
    "field": "payee",
    rules: [
        { required: true, message: '户名不能为空!' },
        { max: 64, message: '户名不能超过64个字符！' },
    ]
}
,{
    "text": "开户行",
    "field": "bankOfDeposit",
    rules: [
        { required: true, message: '开户行不能为空!' },
        { max: 64, message: '开户行不能超过64个字符！' },
    ]
}
,{
    "text": "账号",
    "field": "bankAccounts",
    rules: [
        { required: true, message: '账号不能为空!' },
        { max: 32, message: '账号不能超过32个字符！' },
    ]
}
,{
    "text": "联系电话",
    "field": "contactTel",
    rules: [
        { required: true, message: '联系电话不能为空!' },
        validator.tel
    ]
}
,{
    "text": "地址",
    "field": "memberAddress",
    rules: [
        { required: true, message: '地址不能为空!' },
        { max: 128, message: '地址不能超过128个字符！' },
    ]
}



];


class MemberBankEditForm extends Component {
    state = {}
    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            let url='/memberBank/save'
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
                //url='/barrier/batchVehicleProject/update'
            }
            http.post({
                url: url,
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form,editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                            valuePropName:'value'
                        })(
                            item.member ? <MemberSelect />:<Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="会员账号编辑"
                width={500}
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Row>{this.createDom(fields)}</Row>
                </Form>
            </Modal>
        );
    }
}

const MemberBankEdit = Form.create()(MemberBankEditForm);

export default MemberBankEdit;